module.exports = __webpack_public_path__ + "media/application/images/ui/checkboc-tick-6147e20708dd717fdc6cac8446f26fcf.svg";